import React, { useState, useCallback } from 'react';
import LogoHorizontalIcon from '@moda/icons/logo-horizontal-189-x-12';
import HamburgerIcon from '@moda/icons/hamburger-24';
import FavoriteOutlineIcon from '@moda/icons/favorite-outline-20';
import { Clickable } from '@moda/om';
import { QuickSearch } from '../QuickSearch';
import { MiniCart } from '../MiniCart';
import { Link } from '../Link';
import { MobileSiteNavOverlay } from './MobileSiteNavOverlay';
import './MobileSiteNav.scss';

enum Mode {
  Resting,
  Open
}

export const MobileSiteNav: React.FC = () => {
  const [mode, setMode] = useState(Mode.Resting);

  const handleClick = useCallback(
    () => setMode(prevMode => ({ [Mode.Resting]: Mode.Open, [Mode.Open]: Mode.Resting }[prevMode])),
    []
  );

  const handleClose = useCallback(() => setMode(Mode.Resting), []);

  return (
    <>
      {mode === Mode.Open && <MobileSiteNavOverlay onClose={handleClose} />}

      <nav className="MobileSiteNav" data-testid="mobileNavItems">
        <div className="MobileSiteNav__contents">
          <div className="MobileSiteNav__rail">
            <Clickable
              aria-label="Open Navigation Menu"
              className="MobileSiteNav__hamburger"
              onClick={handleClick}
            >
              <HamburgerIcon />
            </Clickable>

            <Link
              aria-label="Moda Operandi Home Page"
              to="/"
              className="MobileSiteNav__logo"
              data-testid="mobileLogo"
            >
              <LogoHorizontalIcon />
            </Link>

            <div className="MobileSiteNav__actions">
              <Link to="/favorites" aria-label="My Favorites">
                <FavoriteOutlineIcon className="MobileSiteNav__favorite" />
              </Link>
              <MiniCart screen="mobile" />
            </div>
          </div>

          <QuickSearch
            className="MobileSiteNav__search"
            placeholder="What are you looking for?"
            mobile
          />
        </div>
      </nav>
    </>
  );
};
